import React from "react";
import PageHeader from "../../../components/common/PageHeader";
import SearchBar from "../../../components/common/SearchBar";
import ExportMenu from "./ExportMenu";

/**
 * Header component for Price Update page
 * Contains title, search bar, and action buttons
 */
const PriceUpdateHeader = ({
  searchTerm,
  onSearchChange,
  isCompactView,
  onToggleView,
  onExportClick,
  onSubmit,
  hasChanges,
  hasErrors,
  showRecentlyUpdatedOnly,
  onRecentlyUpdatedChange,
  anchorEl,
  onExportClose,
  onExportChanges,
  onExportAll,
}) => {
  return (
    <>
      <PageHeader
        showBackButton={true}
        backTo={-1}
        title="Product Availability/Price Update"
        subtitle={
          <span className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 bg-blue-500 rounded-full"></span>
            Manage product pricing , offers and product availability
          </span>
        }
        action={
          <div className="flex gap-2 flex-wrap">
            <button
              onClick={onToggleView}
              className="bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isCompactView ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                  />
                )}
              </svg>
              {isCompactView ? "Detailed" : "Compact"}
            </button>

            {/* Export Button with Dropdown */}
            <div className="relative">
              <button
                onClick={onExportClick}
                className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                Export
              </button>

              {/* Export Menu Dropdown */}
              <ExportMenu
                anchorEl={anchorEl}
                onClose={onExportClose}
                onExportChanges={onExportChanges}
                onExportAll={onExportAll}
                hasChanges={hasChanges}
              />
            </div>

            <button
              onClick={onSubmit}
              disabled={!hasChanges || hasErrors}
              className="bg-black hover:bg-gray-800 text-white font-medium px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
              Update Prices
            </button>
          </div>
        }
        search={
          <SearchBar
            value={searchTerm}
            onChange={onSearchChange}
            placeholder="Search products by name, category, or subcategory..."
            className="max-w-lg"
          />
        }
      />

      {/* Filter Section */}
      <div className="px-6 pb-4">
        <label className="flex items-center space-x-2 cursor-pointer">
          <input
            type="checkbox"
            checked={showRecentlyUpdatedOnly}
            onChange={onRecentlyUpdatedChange}
            className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
          />
          <span className="text-sm font-medium text-gray-700">
            Show Recently Updated Only
          </span>
        </label>
      </div>
    </>
  );
};

export default PriceUpdateHeader;
